import React, { useEffect } from "react";

export default function FormHosb() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "46247220",
          formId: "4dd833be-9519-4e46-aee1-d5cbacd4064b",
          region: "na1",
          event : "form_hubspot",
          target: "#hs-form",
          onFormReady: () => {
            const interval = setInterval(() => {
              const radios = document.querySelectorAll(
                'input[name="0-2/type"]'
              );
              const industriaSelect = document.querySelector(
                '[name="0-2/industria"]'
              );
              const industriaField = industriaSelect?.closest(".hs-form-field");

              if (!radios.length || !industriaField || !industriaSelect) return;

              // Asegura que el campo esté oculto y sin 'required' al principio
              industriaField.style.display = "none";
              industriaSelect.removeAttribute("required");
              industriaSelect.setAttribute("data-ignore-validation", "true");

              radios.forEach((radio) => {
                const label = radio.closest("label");

                if (radio.value === "Partner" && label) {
                  label.remove();
                }

                radio.addEventListener("change", () => {
                  if (radio.value === "IMEX" && radio.checked) {
                    industriaField.style.display = "block";
                    industriaSelect.setAttribute("required", "true");
                    industriaSelect.removeAttribute("data-ignore-validation");
                  } else if (radio.checked) {
                    industriaField.style.display = "none";
                    industriaSelect.removeAttribute("required");
                    industriaSelect.setAttribute(
                      "data-ignore-validation",
                      "true"
                    );
                    industriaSelect.value = "";
                  }
                });
              });

              clearInterval(interval);
            }, 500);
          },
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className=" flex justify-center items-center w-full ">
      <div className="bg-gradient-to-b from-sidom-orange border-none via-sidom-blue via-50% to-sidom-blue to-40% w-[800px] text-sidom-light rounded-3xl py-20 px-4 sm:px-8 lg:px-16">
        <div className="  flex justify-center items-center w-full ">
          <div id="hs-form" />
        </div>
      </div>
    </section>
  );
}
